import React from 'react'
import { ThemeProvider } from 'react-jss'
import { theme } from '../ui/theme'

import ResponsiveContent from '../ui/Content/ResponsiveContent'
import LocationHeader from '../ui/Location/LocationHeader'
import Accordion from '../ui/Accordion'

const LocationsSubPage = () => {
    const context = JSON.parse(
        atob(
            atob(data)
                .split('')
                .reverse()
                .join(''),
        )
            .split('')
            .reverse()
            .join(''),
    )
    return (
        <ThemeProvider theme={theme}>
            <LocationHeader {...context.Location} />
            <ResponsiveContent {...context.ResponsiveContent} />
            <div style={{ width: '70%', margin: '0 auto', padding: '20px' }}>
                {!_.isEmpty(context.accordion)
                    ? context.accordion.map((row, i) => (
                          <Accordion key={`Accordion${i}`} title={row.title}>
                              <div
                                  dangerouslySetInnerHTML={{
                                      __html: row.body,
                                  }}
                              ></div>
                          </Accordion>
                      ))
                    : ''}
            </div>
        </ThemeProvider>
    )
}

export default LocationsSubPage
